'use client'

import { usePathname } from 'next/navigation'
import Header from '@/components/layout/Header'
import Footer from '@/components/layout/Footer'
import CountryInitializer from '@/components/layout/CountryInitializer'
import { HeaderProvider, useHeaderConfig } from '@/context/HeaderContext'
import { useSiteDomain } from '@/components/providers/SiteDomainProvider'

interface ConditionalLayoutProps {
  children: React.ReactNode
}

function LayoutContent({ children }: ConditionalLayoutProps) {
  const { hideFullHeaderOnScroll, isScrolled } = useHeaderConfig()

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main 
        className={`
          flex-grow w-full max-w-[1400px] mx-auto transition-all duration-300 ease-in-out
          ${hideFullHeaderOnScroll 
            ? isScrolled 
              ? 'pt-[100px] sm:pt-0'   // Con scroll: padding reducido
              : 'pt-[160px] sm:pt-0'  // Sin scroll: padding completo
            : ''                      // Modo por defecto: sin padding extra
          }
        `}
      >
        {children}
      </main>
      <Footer />
    </div>
  )
}

export default function ConditionalLayout({ children }: ConditionalLayoutProps) {
  const pathname = usePathname()
  const view = pathname?.split('/')[2]
  const isChatbot = view === 'chatbot'
  const isMicrosite = view === 'microsite'
  const isSite = view === 'site'
  // [custom-domain] En el dominio personalizado de la organización no hay chrome de RockTheSport,
  // tampoco en las páginas fuera del árbol site (login, signup…).
  const isSiteDomain = useSiteDomain() !== null

  // Microsite, Chatbot and Site have their own independent layouts
  if (isChatbot || isMicrosite || isSite || isSiteDomain) {
    return <>{children}</>
  }

  return (
    <HeaderProvider>
      <CountryInitializer />
      <LayoutContent>
        {children}
      </LayoutContent>
    </HeaderProvider>
  )
}

